import { render, staticRenderFns } from "./UserShareData.vue?vue&type=template&id=f5f630a0&scoped=true"
import script from "./UserShareData.vue?vue&type=script&lang=js"
export * from "./UserShareData.vue?vue&type=script&lang=js"
import style0 from "./UserShareData.vue?vue&type=style&index=0&id=f5f630a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f630a0",
  null
  
)

export default component.exports